export default __webpack_public_path__ + "static/staff-locker-2fd875e6bc6da78aebffcac7dfb813f3.jpg";